import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Calendar } from "primereact/calendar"
import DatePicker from "react-multi-date-picker"
import { useFeaturesTask } from "../../Hooks/Features/ProjectGlance/useFeaturesTask"
import TaskDetailsPopup from "./TaskDetailsPopup"
import { SkeletonContainer } from "../Loader/Loader"

const FeaturesTask = ({ projectId, isFeature, dateFilter, setDateFilter }) => {

    const { changeMonth, date, setDate, detailsPopup, setDetailsPopup, fields, summaryData, getTaskFeaturesSummary, isChange, setIsChange, payloadData, loader, hideCard } = useFeaturesTask({ projectId, isFeature, dateFilter, setDateFilter });

    return (
        <div className="h-100">
            <div className="d-flex align-items-center justify-content-between p-1 pb-2">
                <div className="fs-6 fw-semibold d-flex gap-2 align-items-center p-1 pb-2">
                    <FontAwesomeIcon icon="fa-solid fa-layer-group" />
                    {isFeature ? "Features" : "Tasks"}
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end w60">
                    <div>
                        <DatePicker placeholder="Select Date Range" range rangeHover value={date?.range} onChange={(e) => { setDate((prev) => ({ ...prev, range: e, month: e ? null : new Date() })); setIsChange(true); }} onClose={() => { if (isChange) { setDateFilter(date); getTaskFeaturesSummary(date); setIsChange(false); } }} />
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="d-flex justify-content-center fw-bold c-pointer" onClick={() => changeMonth(-1)}><FontAwesomeIcon icon="fa-solid fa-angle-left" /></div>
                        <span className="month-year d-flex justify-content-center align-items-center inspectra-calendar" >
                            <Calendar view="month" dateFormat="MM yy" className="input-dd" placeholder="Select Month" value={dateFilter?.month || date?.month} onChange={(e) => { setDate((prev) => ({ ...prev, month: e.target?.value, range: [] })); setIsChange(true); }} onHide={() => { if (isChange) { setDateFilter(date); getTaskFeaturesSummary(date); setIsChange(false); } }} />
                        </span>
                        <div className="d-flex justify-content-center fw-bold c-pointer" onClick={() => changeMonth(1)}><FontAwesomeIcon icon="fa-solid fa-angle-right" /></div>

                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-between gap-2">
                {loader ? <div style={{ height: "80px", width: "100%" }}><SkeletonContainer /></div> : fields?.map(item => (
                    !hideCard?.includes(item?.key) && <div key={item?.key} className={`${summaryData?.[item?.key] > 0 ? "project-glance-card-section c-pointer" : ""} d-flex align-items-center gap-2 rounded p-2 w25`} style={{ backgroundColor: "var(--bg-light)" }} onClick={() => { if (summaryData?.[item?.key] > 0) { setDetailsPopup((prev) => ({ ...prev, visible: true, data: item })); } }}>
                        <div className="w90">
                            <FontAwesomeIcon icon={`fa-solid fa-${item?.icon}`} style={{ color: item?.color }} />
                            <div className="text-truncate w100" style={{ color: "var(--text-color)", opacity: 0.7, fontSize: "0.75rem" }}>{item?.label}</div>
                        </div>
                        <div className="fw-bold fs-5">{summaryData?.[item?.key]}</div>
                    </div>
                ))}
            </div>

            {detailsPopup?.visible && <TaskDetailsPopup projectId={projectId} detailsPopup={detailsPopup} onClose={() => setDetailsPopup((prev) => ({ ...prev, visible: false, data: {} }))} header={`${isFeature ? "Features" : "Tasks"} - ${detailsPopup?.data?.label}`} payloadData={payloadData} />}
        </div>
    )
}

export default FeaturesTask